import React, { useState, useEffect } from "react";
//import axios from "axios";
import {
  Divider,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  Typography,
  useTheme,
  Button,
  Checkbox,
  useMediaQuery,
} from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { Link, useHistory } from "react-router-dom";

import { Box } from "@mui/system";
import { gaugeActions, homeActions } from "actions";
import { connect } from "react-redux";
import MessageDialog from "pages/SearchMedication/MessageDialog";
import MainTemplateHeader from "components/MainTemplateHeader";
import CouponDetailsTemplate from "components/CouponDetailsTemplate";
// import { config } from "../../constants";
// import { authHeader } from "../../helpers";
import heartFilledIcon from "assets/images/heartIcon/heart-filled-30.png";

// const LabelValue = (props) => {
//   const { matches, label, value, updateGTMDataLayer, gtmInfo } = props;
//   const tagManagerArgs = {
//     dataLayer: gtmInfo,
//     dataLayerName: "PageDataLayer",
//   };
//   useEffect(() => {
//     if (updateGTMDataLayer) {
//       updateGTMDataLayer({
//         page: "Global",
//         screen: "My Coupons",
//         screen_title: "Global",
//         event: "Nav_my_coupons",
//       });
//     }
//     return () => {
//       if (updateGTMDataLayer) {
//         updateGTMDataLayer({
//           screen_referrer: "My Coupons",
//           page: "Global",
//           screen: "My Coupons",
//           screen_title: "Global",
//           event: "Nav_my_coupons",
//         });
//       }
//     };
//   }, []);

//   useEffect(() => {
//     window.dataLayer.push({
//       ...tagManagerArgs.dataLayer,
//     });
//   }, [gtmInfo]);

//   return (
//     <Box
//       sx={{
//         lineHeight: "24px",
//         display: "flex",
//         paddingRight: "16px",
//       }}
//     >
//       <Typography
//         variant="h3LatoMedium"
//         sx={{
//           fontSize: matches ? "12px" : undefined,
//           display: "inline-block",
//           minWidth: matches ? "74px" : "84px",
//         }}
//       >
//         {label}:
//       </Typography>
//       <Typography
//         variant="h2LatoRegular"
//         sx={{ fontSize: matches ? "14px" : undefined }}
//       >
//         {value}
//       </Typography>
//     </Box>
//   );
// };

const Mycoupons = (props) => {
  const theme = useTheme();
  const matches = useMediaQuery("(max-width:600px)");
  const history = useHistory();
  const [showEdit, setShowEdit] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSuccessErrorDialog, setShowSuccessErrorDialog] = useState(false);
  const [successErrorMessage, setSuccessErrorMessage] = useState("");
  const [showValidationPopup, setShowValidationPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [validationType, setValidationType] = useState("");
  const {
    getMyCoupons,
    myCouponsInfo,
    deleteCoupon,
    deleteCouponInfo,
    resetDeleteCouponInfo,
    resetBrandDetails,
    validateCouponItem,
    selectMyCoupon,
    validateCouponInfo,
    //saveUserInsurance,
    storeAppData,
    organizationInfo,
  } = props;

  useEffect(() => {
    getMyCoupons();
    resetBrandDetails();
    document.getElementById("appcontent").scroll(0, 0);
    storeAppData("brandedInfo", null);
    storeAppData("genericInfo", null);
    return () => {
      resetDeleteCouponInfo();
    };
  }, []);

  const onDeleteSelection = () => {
    setShowConfirmation(false);
    deleteCoupon(selectedItem.savedCouponId);
  };

  // useEffect(() => {
  //   const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));
  //   const storedInsuranceData = JSON.parse(
  //     localStorage.getItem("storedInsuranceData")
  //   );
  //   if (isLoggedIn && storedInsuranceData && storedInsuranceData?.id) {
  //     saveUserInsurance(storedInsuranceData?.id);
  //   }
  // }, []);

  useEffect(() => {
    if (
      validateCouponInfo &&
      Object.keys(validateCouponInfo).length &&
      validateCouponInfo.data
    ) {
      if (validateCouponInfo?.data?.toLowerCase() !== "valid") {
        validateCouponInfo?.data?.toLowerCase() === "insurance"
          ? setValidationType("insurance")
          : setValidationType("invalid");
        setShowValidationPopup(true);
      } else {
        history.push("/CouponDetailsView");
      }
    }
  }, [validateCouponInfo]);

  useEffect(() => {
    if (deleteCouponInfo && deleteCouponInfo.success) {
      setSuccessErrorMessage(deleteCouponInfo.message);
      setShowSuccessErrorDialog(true);
    } else if (
      deleteCouponInfo &&
      Object.keys(deleteCouponInfo).length &&
      !deleteCouponInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(deleteCouponInfo.message);
    }
  }, [deleteCouponInfo]);

  // const unselectFavoritePharmacy = async (e) => {
  //   e.stopPropagation();
  //   const options = {
  //     baseURL: config.apiUrl,
  //     url: `/coupon/unsetfavoritepharmacy`,
  //     method: "GET",
  //     headers: authHeader(),
  //   };
  //   try {
  //     const response = await axios(options);
  //     if (response.status === 200 && response.data.success === true) {
  //       getMyCoupons();
  //       localStorage.setItem("pharmacyGroupId", null);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  return (
    <CouponDetailsTemplate pageTitle="My Coupons">
      <MainTemplateHeader noTitle={true} backTitle={false} />
      <Box component="div" sx={{ position: "relative", padding: "16px" }}>
        <Grid container>
          <Grid item xs={12} sm={10} sx={{ margin: "auto", marginTop: 2 }}>
            <Box>
              {showEdit && myCouponsInfo && myCouponsInfo.length ? (
                <Box
                  component="div"
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outline"
                    onClick={() => setShowEdit(false)}
                    sx={{ boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.16)" }}
                  >
                    Edit
                  </Button>
                </Box>
              ) : null}
              {!showEdit && myCouponsInfo && myCouponsInfo.length ? (
                <Box
                  component="div"
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    variant="outline"
                    disabled={Object.keys(selectedItem).length < 1}
                    sx={{
                      borderColor:
                        Object.keys(selectedItem).length < 1
                          ? "#859aa0"
                          : undefined,
                      boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.16)",
                    }}
                    onClick={() => setShowConfirmation(true)}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="outline"
                    sx={{
                      boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.16)",
                    }}
                    onClick={() => {
                      setShowEdit(true);
                      setSelectedItem({});
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              ) : null}

              {myCouponsInfo && myCouponsInfo.length === 0 ? (
                <Grid
                  item
                  sm={12}
                  mb={2}
                  mt={5}
                  sx={{ textAlign: "center", minHeight: 400 }}
                >
                  <Typography
                    mb={1}
                    component={"div"}
                    variant="h4LatoBold"
                    //sx={{ color: theme.palette.common.greenFour }}
                  >
                    No saved coupon
                  </Typography>

                  <Typography
                    component={Link}
                    to="/SearchMedication"
                    variant="h4LatoBlack"
                    sx={{ color: theme.palette.common.greenFour }}
                  >
                    Get started by searching for a medication
                  </Typography>
                </Grid>
              ) : (
                <Grid item sm={12} mt={2.5} sx={{ minHeight: 400 }}>
                  <Divider />
                  {myCouponsInfo.map((item) => {
                    return (
                      <List sx={{ width: "100%" }} key={item.savedCouponId}>
                        <Box
                          sx={{
                            paddingLeft: "8px",
                            borderRadius: "6px",

                            background: `linear-gradient(to bottom, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge4Color}, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color} 25%, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge2Color} 60%, ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color});`,
                          }}
                        >
                          <ListItemButton
                            sx={{
                              width: "100%",
                              paddingLeft: "16px",
                              paddingRight: 0,
                              paddingBottom: item.logo
                                ? "20px"
                                : matches
                                ? "8px"
                                : "30px",
                              paddingTop: item.logo
                                ? "20px"
                                : matches
                                ? "8px"
                                : "30px",
                              background: "white",
                              "&:hover": {
                                background: "white",
                              },
                            }}
                            onClick={() => {
                              if (
                                selectedItem &&
                                selectedItem.savedCouponId &&
                                selectedItem.savedCouponId ===
                                  item.savedCouponId
                              ) {
                                setSelectedItem({});
                              } else {
                                setSelectedItem(item);
                              }
                              if (showEdit) {
                                selectMyCoupon(item);
                                validateCouponItem(item.savedCouponId);
                              }
                            }}
                          >
                            <Box
                              component="div"
                              sx={{ width: "100%", display: "flex" }}
                            >
                              {!showEdit && (
                                <Box mr={2} sx={{ width: "10%" }}>
                                  <Checkbox
                                    checked={
                                      selectedItem.savedCouponId ===
                                      item.savedCouponId
                                    }
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "24px",
                                        color: "#03952a",
                                      },
                                    }}
                                  />
                                </Box>
                              )}
                              <Box
                                sx={{
                                  display: "flex",
                                  width: showEdit ? "100%" : "90%",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box component="div">
                                  <Box>
                                    <Typography
                                      variant="h3LatoBold"
                                      sx={{
                                        fontSize: matches ? "16px" : undefined,
                                      }}
                                    >
                                      {item.name}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      marginTop: "6px",
                                      marginBottom: "6px",
                                    }}
                                  >
                                    <Typography
                                      variant="h2LatoRegular"
                                      sx={{
                                        fontSize: matches ? "13px" : "16px",
                                      }}
                                    >
                                      {item.strength}, {item.quantity}{" "}
                                      {item.form}
                                    </Typography>
                                  </Box>
                                  {item.logo || item.pharmacyLogoURL ? (
                                    <Box
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={item.logo || item.pharmacyLogoURL}
                                        alt="logo"
                                        style={{
                                          width: "40%", //matches ? "12%" : "25%",
                                          marginRight: "16px",
                                        }}
                                      />
                                      {item?.favoritePharmacyFlag === "Y" ? (
                                        <img
                                          className="fav-heart-icon"
                                          src={heartFilledIcon}
                                          alt="favIcon"
                                        />
                                      ) : null}
                                    </Box>
                                  ) : null}
                                </Box>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Box sx={{ textAlign: "center" }}>
                                    <Typography
                                      variant="h3LatoBlack"
                                      sx={{ color: theme.palette.primary.main }}
                                    >
                                      {item.discountValue}
                                    </Typography>
                                  </Box>
                                  <ListItemIcon sx={{ minWidth: "30px" }}>
                                    <ChevronRight
                                      sx={{
                                        color: theme.palette.common.greenThree,
                                      }}
                                      fontSize="large"
                                    />
                                  </ListItemIcon>
                                </Box>
                              </Box>
                            </Box>
                          </ListItemButton>
                        </Box>
                        <Divider />
                      </List>
                    );
                  })}
                </Grid>
              )}
            </Box>
            {showConfirmation ? (
              <MessageDialog showPopUp={showConfirmation}>
                <Box mb={4.5}>
                  <Typography variant="h1LatoMedium">
                    Deleting this coupon also deletes daily{" "}
                    {matches ? null : <br />}
                    dose and refill savings reminders.
                  </Typography>
                </Box>
                <Box mb={5}>
                  <Typography variant="h3LatoBlack" sx={{ fontSize: "20px" }}>
                    Delete this coupon?
                  </Typography>
                </Box>
                <Box mb={4}>
                  <Button
                    variant="large"
                    onClick={() => onDeleteSelection()}
                    sx={{
                      width: matches ? "250px" : "420px",
                      minWidth: matches ? "200px" : undefined,
                    }}
                  >
                    Delete
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="text"
                    onClick={() => {
                      setShowConfirmation(false);
                      setSelectedItem({});
                    }}
                    sx={{
                      width: matches ? "250px" : "420px",
                      minWidth: matches ? "200px" : undefined,
                      textDecoration: "underline",
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </MessageDialog>
            ) : null}
            {showSuccessErrorDialog ? (
              <MessageDialog showPopUp={showSuccessErrorDialog}>
                <Box
                  component="div"
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <Box mb={7}>
                    <Typography variant="text2">
                      {successErrorMessage}
                    </Typography>
                  </Box>
                  <Box>
                    <Button
                      variant="large"
                      onClick={() => {
                        getMyCoupons();
                        setSelectedItem({});
                        resetDeleteCouponInfo();
                        setShowSuccessErrorDialog(false);
                      }}
                      sx={{
                        minWidth: { xs: "150px", sm: "150px", md: undefined },
                      }}
                    >
                      DONE
                    </Button>
                  </Box>
                </Box>
              </MessageDialog>
            ) : null}

            {showValidationPopup ? (
              <MessageDialog showPopUp={showValidationPopup}>
                <>
                  <Box mb={"24px"}>
                    {validationType === "insurance" ? (
                      <Typography variant="h2LatoBold">
                        This coupon was covered under your old{" "}
                        {matches ? null : <br />} insurance plan.
                      </Typography>
                    ) : (
                      <Typography variant="h2LatoBold">
                        This coupon is no longer valid.
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ marginBottom: "20px" }}>
                    <Typography
                      variant="h4LatoMedium"
                      sx={{ color: "#607277", fontSize: "16px" }}
                    >
                      Would you like to check if it’s covered by{" "}
                      {matches ? null : <br />} your new insurance?
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: "56px" }}>
                    <Button
                      variant="large"
                      sx={{
                        width: matches ? "250px" : "420px",
                        minWidth: matches ? "200px" : undefined,
                      }}
                      component={Link}
                      to={`/SearchMedication/${selectedItem.name}`}
                      onClick={() => {
                        resetDeleteCouponInfo();
                      }}
                    >
                      SEARCH
                    </Button>
                  </Box>
                  <Box sx={{ marginBottom: "24px" }}>
                    <Typography variant="h2LatoBold">
                      Would you like to delete this coupon?
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: "20px" }}>
                    <Typography
                      variant="h4LatoMedium"
                      sx={{ color: "#607277", fontSize: "16px" }}
                    >
                      Deleting this coupon also deletes daily dose{" "}
                      {matches ? null : <br />} and refill savings reminders.
                    </Typography>
                  </Box>
                  <Box>
                    <Button
                      variant="large"
                      sx={{
                        width: matches ? "250px" : "420px",
                        minWidth: matches ? "200px" : undefined,
                      }}
                      onClick={() => {
                        setShowValidationPopup(false);
                        setShowConfirmation(true);
                        resetDeleteCouponInfo();
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                  <Box mt={3}>
                    <Button
                      variant="text"
                      sx={{
                        width: matches ? "250px" : "420px",
                        minWidth: matches ? "200px" : undefined,
                      }}
                      onClick={() => {
                        setSelectedItem({});
                        setShowValidationPopup(false);
                        resetDeleteCouponInfo();
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </>
              </MessageDialog>
            ) : null}
          </Grid>
        </Grid>
      </Box>
    </CouponDetailsTemplate>
  );
};

function mapStateToProps(state) {
  return {
    myCouponsInfo: state.myCoupons.data || [],
    validateCouponInfo: state.validateCouponInfo || {},
    gtmInfo: state.gtmInfo.data,
    deleteCouponInfo: state.deleteCouponInfo.data,
    organizationInfo: state.organizationInfo.data || {},
  };
}

const mapDispatchToProps = {
  getMyCoupons: (value) => homeActions.myCoupons(value),
  deleteCoupon: (value) => homeActions.deleteCoupon(value),
  validateCouponItem: (value) => homeActions.validateCouponItem(value),
  selectMyCoupon: (value) => homeActions.selectMyCoupon(value),
  resetDeleteCouponInfo: () => homeActions.resetDeleteCouponInfo(),
  storeAppData: (type, value) => homeActions.storeAppData(type, value),
  resetBrandDetails: () => gaugeActions.resetBrandDetails(),
  //saveUserInsurance: (value) => homeActions.saveUserInsurance(value),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(Mycoupons);
